import * as React from 'react';

/**
 * Calendar Checkmark Icon
 *
 * @returns
 */
function CalendarCheckmarkSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 34 32"
			className={'icon icon-calendar-checkmark ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
			data-testid={svgProps.testId}
		>
			<path d="M7.698 6.621c0 0 0 0 0 0 1.2 0 2.173-0.972 2.175-2.171v-2.278c-0.046-1.165-1.001-2.091-2.173-2.091s-2.127 0.927-2.173 2.087l-0 0.004v2.277c0 1.199 0.972 2.172 2.172 2.172v0z" />
			<path d="M21.2 29.793h-18.993v-18.759h24.276v10.37l2.207-3.528v-12.359c0-1.219-0.988-2.207-2.207-2.207v0h-2.207v1.103c0 1.828-1.482 3.31-3.31 3.31s-3.31-1.482-3.31-3.31v0-1.103h-6.621v1.103c0 1.828-1.482 3.31-3.31 3.31s-3.31-1.482-3.31-3.31v0-1.103h-2.207c-1.219 0-2.207 0.988-2.207 2.207v0 24.276c0 1.219 0.988 2.207 2.207 2.207h20.664z" />
			<path d="M15.448 18.759h3.31v3.31h-3.31v-3.31z" />
			<path d="M20.93 6.621c1.197-0.004 2.165-0.974 2.165-2.172 0 0 0 0 0 0v0-2.277c-0.046-1.165-1.001-2.091-2.173-2.091s-2.127 0.927-2.173 2.087l-0 0.004v2.277c0 0 0 0 0 0 0 1.199 0.972 2.172 2.172 2.172 0.003 0 0.007 0 0.010-0h-0.001z" />
			<path d="M20.966 21.812c0.595-0.355 1.312-0.566 2.079-0.566 0.2 0 0.397 0.014 0.59 0.042l-0.022-0.003c0.251 0.033 0.475 0.085 0.691 0.155l-0.027-0.008v-2.675h-3.31z" />
			<path d="M15.448 24.276h3.31v3.31h-3.31v-3.31z" />
			<path d="M20.966 13.241h3.31v3.31h-3.31v-3.31z" />
			<path d="M15.448 13.241h3.31v3.31h-3.31v-3.31z" />
			<path d="M4.414 24.276h3.31v3.31h-3.31v-3.31z" />
			<path d="M4.414 13.241h3.31v3.31h-3.31v-3.31z" />
			<path d="M4.414 18.759h3.31v3.31h-3.31v-3.31z" />
			<path d="M9.931 18.759h3.31v3.31h-3.31v-3.31z" />
			<path d="M9.931 24.276h3.31v3.31h-3.31v-3.31z" />
			<path d="M9.931 13.241h3.31v3.31h-3.31v-3.31z" />
			<path d="M26.242 30.852c-0.001 0-0.003 0-0.005 0-0.403 0-0.761-0.193-0.987-0.491l-0.002-0.003-3.192-4.215c-0.156-0.206-0.25-0.468-0.25-0.751 0-0.691 0.56-1.251 1.251-1.251 0.408 0 0.77 0.195 0.999 0.497l0.002 0.003 2.101 2.771 5.277-8.488c0.224-0.354 0.613-0.586 1.057-0.586 0.688 0 1.246 0.558 1.246 1.246 0 0.244-0.070 0.472-0.192 0.664l0.003-0.005-6.252 10.021c-0.212 0.338-0.574 0.566-0.991 0.587l-0.003 0z" />
		</svg>
	);
}

CalendarCheckmarkSVG.defaultProps = { class: '' };

export default CalendarCheckmarkSVG;
